import React from "react";
import "./ChangingText.css";

import MovingText from 'react-moving-text'

const ChangingText = () => {
  return (
    <>
      <div className="description">
        <span>I'M</span>
        <div className="message">
          <MovingText
            type="typewriter"
            duration="5000ms"
            dataText={["ROHAN KUMAR PANDEY", "A FRONT-END DEVELOPER", "A CONTENT CREATOR"]}
          />
        </div>
      </div>
    </>
  );
};

export default ChangingText;
